import { CSVLink } from 'react-csv';
import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { body2, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Cell = styled.div`
  ${body2};
  box-sizing: border-box;
  display: table-cell;
  overflow-y: visible;
  padding: ${spacing.threeQuarter};
  margin: 0;
  height: ${spacing.x3};
  vertical-align: middle;
`;

export const TooltipWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: inherit;
`;

export const TooltipCardinalityTrigger = styled.div`
  display: flex;
  align-items: center;
`;

export const CenterText = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  gap: ${spacing.base};
`;

export const RightAlignText = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: end;
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
  color: ${colors.borderPrimary};
`;

export const StyledPage = styled.div`
  margin: ${pxToRem(-20)} ${pxToRem(-40)} ${pxToRem(-40)};
  background: ${colors.backgroundSecondary};
`;

export const HiddenCSVLink = styled(CSVLink)`
  display: none;
`;

export const TabularNumberFont = styled.div`
  font-feature-settings: 'tnum';
`;
